// user-preferences-model.ts — Current-user suite, preference value model.

export interface SessionFoldPreferences {
  topPanelFolded: boolean;
  chatFolded: boolean;
  overviewFolded: boolean;
  contentVersionRenderMode: SessionContentVersionRenderMode;
}

export enum SessionContentVersionRenderMode {
  Full = 'full',
  Accordion = 'accordion',
}

export interface UserPreferences extends Record<string, unknown> {
  chatComposerRounds: number;
  sessionControlRounds: number;
  enterToSend: boolean;
  lastSessionLayout: SessionFoldPreferences;
  sessionFoldPreferences: Record<string, SessionFoldPreferences>;
}

export type UserPreferencesUpdater =
  | UserPreferences
  | ((previousValue: UserPreferences) => UserPreferences);

export type SetUserPreferencesCookieValue = (
  nextValueOrUpdater: UserPreferencesUpdater,
) => void;

export interface UserPreferenceScalarActions {
  setPrefs: (next: Partial<UserPreferences>) => void;
  setChatComposerRounds: (value: number) => void;
  setSessionControlRounds: (value: number) => void;
  setEnterToSend: (value: boolean) => void;
}

export interface UserPreferenceSessionFoldActions {
  setSessionFoldPreferences: (
    sessionId: string,
    next: Partial<SessionFoldPreferences>,
  ) => void;
  seedSessionFoldPreferencesIfAbsent: (sessionId: string) => void;
}

export type UserPreferenceActions =
  UserPreferenceScalarActions & UserPreferenceSessionFoldActions;

export const USER_PREFERENCES_COOKIE_SUB_PATH = 'userConvenience';
export const CHAT_COMPOSER_MINIMUM_ROUNDS = 0;
export const SESSION_CONTROL_MINIMUM_ROUNDS = 1;

export const SESSION_FOLD_PREFERENCES_DEFAULTS: SessionFoldPreferences = {
  topPanelFolded: false,
  chatFolded: false,
  overviewFolded: false,
  contentVersionRenderMode: SessionContentVersionRenderMode.Full,
};

export const USER_PREFERENCES_DEFAULTS: UserPreferences = {
  chatComposerRounds: 2,
  sessionControlRounds: 2,
  enterToSend: false,
  lastSessionLayout: SESSION_FOLD_PREFERENCES_DEFAULTS,
  sessionFoldPreferences: {},
};
